export default {
    install (Vue, opt) {
        Vue.prototype.getCurrentYear = function () {
            return (new Date().getFullYear())
        }

        /**
         * 获取距离顶部的高度
         * @param clientHeight 实际尺寸高度，不包括margin和border
         * @returns {number}
         */
        Vue.prototype.getClientTop = function (clientHeight) {
            let top = (window.screen.height - clientHeight) / 2 - (window.screen.availHeight - window.innerHeight) - 100
            if (top < 0) {
                top = 0
            }
            return top
        }

        /**
         * 是否是string
         * @param str
         * @returns {boolean}
         */
        Vue.prototype.isString = function (str) {
            return Object.prototype.toString.call(str) === '[object String]'
        }

        /**
         * 是否是数字
         * @param str
         * @returns {boolean}
         */
        Vue.prototype.isNumber = function (str) {
            return str.toString().match(/^[0-9]+\.{0,1}[0-9]{0,2}$/) !== null
        }

        /**
         * 是否是数组
         * @param o
         * @returns {boolean}
         */
        Vue.prototype.isArray = function (o) {
            return Object.prototype.toString.call(o) === '[object Array]'
        }

        /**
         * 是否是对象
         * @param o
         * @returns {boolean}
         */
        Vue.prototype.isObject = function (o) {
            return typeof o === 'object'
        }

        /**
         * 是否是手机
         * @param mobile
         * @returns {boolean}
         */
        Vue.prototype.isMobile = function (mobile) {
            let regex = /^1(3|4|5|6|7|8|9)\d{9}$/
            if (regex.test(mobile)) {
                return true
            } else {
                return false
            }
        }

        /**
         * 是否是Json
         * @param str
         * @returns {boolean}
         */
        Vue.prototype.isJson = function (str) {
            if (/^[\],:{}\s]*$/.test(str.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
                return true
            } else {
                return false
            }
        }

        /**
         * 字符串长度
         * @param str
         * @returns {number}
         */
        Vue.prototype.strLength = function (str) {
            let realLength = 0, len = str.length, charCode = -1
            for (let i = 0; i < len; i++) {
                charCode = str.charCodeAt(i)
                if (charCode >= 0 && charCode <= 128) {
                    realLength += 1
                } else {
                    realLength += 2
                }
            }
            return realLength
        }

        /**
         * 反转字符串
         * @param str
         * @returns {string}
         */
        Vue.prototype.strReverse = function (str) {
            return str.toString().split('').reverse().join('')
        }

        /**
         * 去除空格
         * @param str
         * @returns {*}
         */
        Vue.prototype.strTrim = function (str) {
            return str.replace(/(^\s*)|(\s*$)/g, '')
        }

        /**
         * 是否是空
         * @param str
         * @returns {boolean}
         */
        Vue.prototype.isEmpty = function (str) {
            if (typeof (str) === 'undefined' || str === 0 || str === '' || str === '0' || str === 'null' || str === null || str === false || str === undefined || (this.isString(str) && this.strTrim(str).length === 0) || (this.isArray(str) && str.length === 0)) {
                return true
            } else if (this.isObject(str)) {
                let is_empty = true
                for (let prop in str) {
                    is_empty = false
                    break
                }
                return is_empty
            } else {
                return false
            }
        }

        /**
         * 以字母开头，长度在min~max之间，只能包含字符、数字和下划线
         * @param str
         * @param min
         * @param max
         * @returns {boolean}
         */
        Vue.prototype.isPassword = function (str, min, max) {
            max = parseInt(max)
            //max--;
            min = parseInt(min)
            //min--;
            let reg = new RegExp('^[0-9A-Za-z]{' + min + ',' + max + '}$')
            return str.match(reg) !== null
        }

        /**
         * 简单密码
         * @param str
         * @param min
         * @returns {boolean}
         */
        Vue.prototype.isPasswordAZaz09 = function (str, min) {
            let reg = new RegExp('(\\w){' + min + ',}$', 'g')
            return str.match(reg) !== null
        }

        /**
         * 获取
         * @param name
         * @returns {string}
         */
        Vue.prototype.cookieGet = function (name) {
            let cookieArray = document.cookie.split('; ') //得到分割的cookie名值对
            for (let i = 0; i < cookieArray.length; i++) {
                let arr = cookieArray[i].split('=')       //将名和值分开
                //如果是指定的cookie，则返回它的值
                if (arr[0] === name) {
                    return decodeURI(arr[1])
                }
            }
            return ''
        }

        /**
         * 删除
         * @param name
         */
        Vue.prototype.cookieDel = function (name) {
            let d = new Date()
            d.setTime(d.getTime() - 1)
            document.cookie = name + '=; expires=' + d.toGMTString() + ';path=/'
        }

        /**
         * 添加
         * @param name
         * @param value
         * @param seconds
         */
        Vue.prototype.cookieAdd = function (name, value, seconds) {
            let str = name + '=' + encodeURI(value)
            if (seconds > 0) {
                let date = new Date()
                seconds = seconds * 1000
                date.setTime(date.getTime() + seconds)
                str += '; expires=' + date.toGMTString()
            }
            //写到主域名
            let host = window.location.host
            if (host.indexOf('.') !== host.lastIndexOf('.')) {
                //主域名
                host = host.substr(host.indexOf('.') + 1)
            }
            document.cookie = str + ';path=/;domain=' + host
        }

        /**
         * 清除所有cookie
         */
        Vue.prototype.cookieRemoveAll = function () {
            //主域名
            let host = window.location.host
            if (host.indexOf('.') !== host.lastIndexOf('.')) {
                //主域名
                host = host.substr(host.indexOf('.') + 1)
            }
            var keys = document.cookie.match(/[^ =;]+(?=\=)/g)
            if (keys) {
                for (var i = keys.length; i--;) {
                    document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
                    document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() + ';domain=' + host
                }
            }
        }

        /**
         * 获取主域名
         * @param host
         * @returns {string}
         */
        Vue.prototype.getPrimaryDomain = function (host) {
            if (host.indexOf('.') !== host.lastIndexOf('.')) {
                //主域名
                host = host.substr(host.indexOf('.') + 1)
            }
            //去除无用字符
            host = host.replace('/', '')
            return host
        }

        /**
         * 退出
         */
        Vue.prototype.logout = function () {
            localStorage.removeItem('jwt')
            localStorage.removeItem('avatar')
            localStorage.removeItem('username')
            localStorage.removeItem('email')
        }

        /**
         * 设置jwt
         * @param jwt
         */
        Vue.prototype.setJwt = function (jwt) {
            return localStorage.setItem('jwt', jwt)
        }

        /**
         * 获取jwt
         * @returns {string}
         */
        Vue.prototype.getJwt = function () {
            return localStorage.getItem('jwt')
        }

        /**
         * 获取服务器地址
         * @returns {string}
         */
        Vue.prototype.getServerUrl = function () {
            return localStorage.getItem('ServerUrl')
        }

        /**
         * 错误信息
         * @param msg
         */
        Vue.prototype.showError = function (msg) {
            this.$message.error(msg)
        }

        /**
         * 成功信息
         * @param msg
         */
        Vue.prototype.showSuccess = function (msg) {
            this.$message.success(msg)
        }

        /**
         * 邮箱
         * @param email
         * @returns {boolean}
         */
        Vue.prototype.isEmail = function (email) {
            let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/
            let res = regex.test(email)
            res = ((email !== '') && res)
            return res
        }

        /**
         * 身份证校验
         * @param code
         * @returns {{result: boolean, msg: string}}
         */
        Vue.prototype.isIdCard = function (code) {
            // 根据〖中华人民共和国国家标准 GB 11643-1999〗中有关公民身份号码的规定，公民身份号码是特征组合码，由十七位数字本体码和一位数字校验码组成。排列顺序从左至右依次为：六位数字地址码，八位数字出生日期码，三位数字顺序码和一位数字校验码。
            // 地址码表示编码对象常住户口所在县(市、旗、区)的行政区划代码。
            // 出生日期码表示编码对象出生的年、月、日，其中年份用四位数字表示，年、月、日之间不用分隔符。
            // 顺序码表示同一地址码所标识的区域范围内，对同年、月、日出生的人员编定的顺序号。顺序码的奇数分给男性，偶数分给女性。
            // 校验码是根据前面十七位数字码，按照ISO 7064:1983.MOD 11-2校验码计算出来的检验码。
            //
            // 出生日期计算方法。
            // 15位的身份证编码首先把出生年扩展为4位，简单的就是增加一个19或18,这样就包含了所有1800-1999年出生的人;
            // 2000年后出生的肯定都是18位的了没有这个烦恼，至于1800年前出生的,那啥那时应该还没身份证号这个东东，⊙﹏⊙b汗...
            // 下面是正则表达式:
            // 出生日期1800-2099  (18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])
            // 身份证正则表达式 /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i
            // 15位校验规则 6位地址编码+6位出生日期+3位顺序号
            // 18位校验规则 6位地址编码+8位出生日期+3位顺序号+1位校验位
            //
            // 校验位规则     公式:∑(ai×Wi)(mod 11)……………………………………(1)
            // 公式(1)中：
            // i----表示号码字符从由至左包括校验码在内的位置序号；
            // ai----表示第i位置上的号码字符值；
            // Wi----示第i位置上的加权因子，其数值依据公式Wi=2^(n-1）(mod 11)计算得出。
            // i 18 17 16 15 14 13 12 11 10 9 8 7 6 5 4 3 2 1
            // Wi 7 9 10 5 8 4 2 1 6 3 7 9 10 5 8 4 2 1
            // 身份证号合法性验证
            // 支持15位和18位身份证号
            // 支持地址编码、出生日期、校验位验证
            let city = {
                11: '北京',
                12: '天津',
                13: '河北',
                14: '山西',
                15: '内蒙古',
                21: '辽宁',
                22: '吉林',
                23: '黑龙江',
                31: '上海',
                32: '江苏',
                33: '浙江',
                34: '安徽',
                35: '福建',
                36: '江西',
                37: '山东',
                41: '河南',
                42: '湖北',
                43: '湖南',
                44: '广东',
                45: '广西',
                46: '海南',
                50: '重庆',
                51: '四川',
                52: '贵州',
                53: '云南',
                54: '西藏',
                61: '陕西',
                62: '甘肃',
                63: '青海',
                64: '宁夏',
                65: '新疆',
                71: '台湾',
                81: '香港',
                82: '澳门',
                91: '国外'
            }
            let tip = ''
            let pass = true
            if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
                tip = '身份证号格式错误'
                pass = false
            } else if (!city[code.substr(0, 2)]) {
                tip = '地址编码错误'
                pass = false
            } else {
                //18位身份证需要验证最后一位校验位
                if (code.length === 18) {
                    code = code.split('')
                    //∑(ai×Wi)(mod 11)
                    //加权因子
                    let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
                    //校验位
                    let parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
                    let sum = 0
                    let ai = 0
                    let wi = 0
                    for (let i = 0; i < 17; i++) {
                        ai = code[i]
                        wi = factor[i]
                        sum += ai * wi
                    }
                    if (parity[sum % 11] !== code[17]) {
                        tip = '校验位错误'
                        pass = false
                    }
                }
            }
            return {
                result: pass,
                msg: tip
            }
        }

        Vue.prototype.idCheck = function (idCard) {
            let flag = false
            //15位和18位身份证号码的正则表达式
            let regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/
            //如果通过该验证，说明身份证格式正确，但准确性还需计算
            if (regIdCard.test(idCard)) {
                if (idCard.length === 18) {
                    let idCardWi = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2) //将前17位加权因子保存在数组里
                    let idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2) //这是除以11后，可能产生的11位余数、验证码，也保存成数组
                    let idCardWiSum = 0 //用来保存前17位各自乖以加权因子后的总和
                    for (let i = 0; i < 17; i++) {
                        idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i]
                    }
                    let idCardMod = idCardWiSum % 11//计算出校验码所在数组的位置
                    let idCardLast = idCard.substring(17)//得到最后一位身份证号码
                    //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
                    if (idCardMod === 2) {
                        if (idCardLast === 'X' || idCardLast === 'x') {
                            flag = true
                        } else {
                            flag = false
                        }
                    } else {
                        //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
                        if (idCardLast === idCardY[idCardMod]) {
                            flag = true
                        } else {
                            flag = false
                        }
                    }
                } else if (idCard.length === 15) {
                    let id17 = idCard.substring(0, 6) + '19' + idCard.substring(6)
                    let parityBit = getParityBit(id17)
                    let tempIdCard = id17 + parityBit
                    flag = this.idCheck(tempIdCard)
                }
            } else {
                flag = false
            }
            return flag
        }

        /**
         * 获取所有参数
         * @returns {{}}
         */
        Vue.prototype.getParams = function () {
            let url = window.location.href
            if (url.indexOf('?') === -1) {
                return {}
            }
            let str = url.split('?')[1]
            str = str.split('#')[0]
            str = str.split('&')
            let params = {}
            let item = []
            for (let i = 0; i < str.length; i++) {
                item = str[i].split('=')
                //url解码
                params[item[0]] = decodeURIComponent(item[1])
            }
            return params
        }

        /**
         * 时间补0
         * @param d
         * @returns {string|*}
         */
        Vue.prototype.dateAddZero = function (d) {
            return parseInt(d, 10) < 10 ? '0' + d : d
        }

    }
}



//////////////////
// WEBPACK FOOTER
// ./static/js/common.js
// module id = null
// module chunks = 